import React from 'react';
import LoadingSpinner from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';
import styles from './IndexPageStyles';

export const IndexAreaLoadingSpinner = ({ loading, data, children }) => {
  if (loading && data) {
    return (
      <div className={styles.loadingAreaContainer}>
        <div className={styles.loadingArea}>
          <div className={styles.loadingSpinnerPosition}>
            <LoadingSpinner size="medium" />
          </div>
        </div>
        {children}
      </div>
    );
  }
  return children;
};

export const IndexTitle = ({ children }) => {
  if (children && typeof children === 'function') {
    return children({ titleStyle: styles.indexTitle });
  }
  return <div className={styles.indexTitle}>{children}</div>;
};

export const IndexArea = ({ children }) => {
  return <div className={styles.mainIndexPageArea}>{children}</div>;
};

export const LeftSidebar = ({ children, ...props }) => {
  if (children && typeof children === 'function') {
    return children({ leftSidebarStyle: styles.leftSidebar });
  }
  return (
    <aside className={styles.leftSidebar} {...props}>
      {children}
    </aside>
  );
};

const IndexPage = ({ children }) => {
  return (
    <div className={styles.main}>
      <div className={styles.indexPageContainer}>{children}</div>
    </div>
  );
};

export default IndexPage;
